import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import '~/apps/App.css';
import '~/apps/common.css';

function LocalMenuSelect({items, selectedItem, setSelectedItem, attribute, seeAllTitle, filter}) {

    // todo: potentially sort in parent
    const sortedItems = items.sort();

    let addClass = "";

    if (seeAllTitle === "Title") {
        addClass = "title";
    }
    if (seeAllTitle === "Departments") {
        addClass = "dept";
    }

    return <FormControl sx={{ m: 1, minWidth: 120 }} className={addClass}>
        <Select
            native
            variant="outlined"
            inputProps={{
                name: attribute,
                id: attribute,
            }}
            className="ds-select"
            value={selectedItem || ''}
            onChange={
                e => {
                    e.stopPropagation();
                    setSelectedItem(e.currentTarget.value);
                }
            }
            margin="dense"
        >
            <option value="">{seeAllTitle + (filter ? " (" + sortedItems.length + ")" : "")} </option>
            {sortedItems.map(item => <option key={item} value={item}>{item}</option>)}
        </Select>
    </FormControl>;
}

export default LocalMenuSelect;